import script from "./UserDetailsHeadLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetailsHeadLoader.vue?vue&type=script&setup=true&lang=js"

import "./UserDetailsHeadLoader.vue?vue&type=style&index=0&id=addd7f50&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-addd7f50"]])

export default __exports__